import { render, staticRenderFns } from "./SalesReports.vue?vue&type=template&id=77cc0ae0&scoped=true"
import script from "./SalesReports.vue?vue&type=script&setup=true&lang=js"
export * from "./SalesReports.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SalesReports.vue?vue&type=style&index=0&id=77cc0ae0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77cc0ae0",
  null
  
)

export default component.exports